
import {Component, Vue, Watch} from "vue-property-decorator";
import {ROWS_PER_PAGE} from "@/utils/constants";
import CustomerSuccessAddUserModal from "@/components/customerSuccess/CustomerSuccessAddUserModal.vue";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
  components: {CustomerSuccessAddUserModal, SimpleDialog},
})
export default class CustomerSuccess extends Vue {

  private users: object[] = [];
  private headers: object[] = [
    {value: "firstName", sortable: true},
    {value: "lastName", sortable: true},
    {value: "email", sortable: true},
    {value: "lastLoginAt", sortable: true},
    {value: "action", sortable: false},
  ];
  private loading: boolean = true;
  private addUserDialog: boolean = false;
  private removedUser: any = null;
  private removeDialog: boolean = false;
  private removing: boolean = false;

  private pagination: any = {
    sortDesc: [true],
    sortBy: ["lastLoginAt"],
    page: 1,
    itemsPerPage: 10,
    totalItems: 10,
  };

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  @Watch("pagination", {deep: true})
  public handler() {
    this.getUsers();
  }

  private getUsers() {
    this.loading = true;
    return this.$store.dispatch("admin/customerSuccess/read", {query: this.pagination})
      .then((res) => {
        this.users = res.rows;
        this.pagination.totalItems = res.count;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private clickRow(item) {
    this.$router.push({name: "admin-customer-success-detail", params: {id: item.id}});
  }

  private openRemoveDialog(item): void {
    this.removedUser = item;
    this.removeDialog = true;
  }

  private closeRemoveDialog(): void {
    this.removedUser = null;
    this.removeDialog = false;
  }

  private removeUser(): void {
    this.removing = true;
    this.$store.dispatch("admin/customerSuccess/removeUser", {
      userId: this.removedUser.id,
    }).then(() => {
      this.closeRemoveDialog();
      this.getUsers();
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", {error});
    }).finally(() => {
      this.removing = false;
    });
  }
}
